import store from '@/store'
export default [
  {
    path: '/branches',
    name: 'branch',
    meta: { requiresAuth: true },
    component: () => import('@/pages/branch/index-v2.vue')
  },
  {
    path: '/branches/create',
    name: 'branch-create',
    meta: { requiresAuth: true },
    component: () => import('@/pages/branch/create.vue'),
    beforeEnter: async (to, from, next) => {
      await store.dispatch('branch/dataBeforeCreate')
      next()
    }
  },
  {
    path: '/branches/:id',
    name: 'branch-edit',
    meta: { requiresAuth: true },
    component: () => import('@/pages/branch/edit.vue'),
    beforeEnter: async (to, from, next) => {
      await store.dispatch('branch/dataBeforeCreate')
      await store.dispatch('branch/find', to.params.id)
      next()
    }
  }
]
